// extracted by mini-css-extract-plugin
module.exports = {"import":"BuildingImportDocumentation_import__1oTDm","seelct":"BuildingImportDocumentation_seelct__3y5b5"};